import React, { useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { FaEnvelope, FaPaperclip } from 'react-icons/fa';

const EmailDocumentModal = ({ show, onHide, onSend, document, clientName, clientEmail }) => {
  const [formData, setFormData] = useState({
    subject: `${document ? document.DocumentName : 'Project Proposal'} from Milan Peich Construction`,
    message: `Dear ${clientName},\n\nI have attached the ${document ? document.DocumentName : 'proposal'} for your review.\n\nPlease let me know if you have any questions.\n\nBest regards,\nMilan Peich\nMilan Peich Construction`
  });
  const [sending, setSending] = useState(false);

  // Handle form change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!clientEmail) {
      toast.error('Client email is not available. Please add an email to the client first.');
      return;
    }

    setSending(true);
    
    try {
      await onSend(formData);
      onHide();
    } catch (error) {
      console.error('Error sending email:', error);
    } finally {
      setSending(false);
    }
  };

  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title><FaEnvelope className="me-2" /> Email Document to Client</Modal.Title>
      </Modal.Header>
      
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>To</Form.Label>
            <Form.Control
              type="text"
              value={clientEmail || 'No email available'}
              disabled
            />
            {!clientEmail && (
            <Alert variant="danger" className="mb-3">
            This client doesn't have an email address. Please add an email to the client first.
            </Alert>
            )}
          </Form.Group>
          
          <Form.Group className="mb-3">
            <Form.Label>Subject</Form.Label>
            <Form.Control
              type="text"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              required
            />
          </Form.Group>
          
          <Form.Group className="mb-3">
            <Form.Label>Message</Form.Label>
            <Form.Control
              as="textarea"
              rows={6}
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
            />
          </Form.Group>
          
          <div className="mb-3 p-3 border rounded bg-light">
            <strong><FaPaperclip className="me-1" /> Attachment:</strong> {document ? document.DocumentName : 'No document selected'}
          </div>
        </Modal.Body>
        
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide} disabled={sending}>
            Cancel
          </Button>
          <Button 
            type="submit" 
            variant="primary"
            disabled={sending || !clientEmail}
          >
            {sending ? 'Sending...' : 'Send Email'} <FaEnvelope className="ms-1" />
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default EmailDocumentModal;
